import { create } from 'zustand'

type Lang = 'en' | 'ko' | 'zh-CN' | 'zh-TW' | 'jp'

type LangState = {
  lang: Lang
  setLang: (newLang: Lang) => void
}
const getLanguageFromCookie = (): Lang => {
  if (typeof window !== 'undefined') {
    const match = document.cookie.match(/lang=([^;]+)/)
    return match ? (match[1] as Lang) : 'ko'
  }
  return 'ko'
}

export const useLang = create<LangState>((set) => ({
  lang: getLanguageFromCookie(),
  setLang: (newLang) => {
    const expires = new Date()
    expires.setFullYear(expires.getFullYear() + 1)
    document.cookie = `lang=${newLang}; path=/; expires=${expires.toUTCString()}; Secure; SameSite=Strict`
    set({ lang: newLang })
  }
}))
